import mpanel from '../../../assets/images/main-panel.png'
import mpanelIcon from '../../../assets/images/main-panel-icon.png'
import andComponent from '../../../assets/images/and-component.png'
import orComponent from '../../../assets/images/or-component.png'
import moreComponent from '../../../assets/images/more-component.png'
import lessComponent from '../../../assets/images/less-component.png'
import equalComponent from '../../../assets/images/equal-component.png'
import upComponent from '../../../assets/images/up-component.png'
import downComponent from '../../../assets/images/down-component.png'
import rsiComponent from '../../../assets/images/rsi.png'
import smaComponent from '../../../assets/images/sma.png'
import emaComponent from '../../../assets/images/ema.png'
import macdComponent from '../../../assets/images/macd.png'
import andComponentIcon from '../../../assets/images/and-component-icon.png'
import orComponentIcon from '../../../assets/images/or-component-icon.png'
import moreComponentIcon from '../../../assets/images/more-component-icon.png'
import lessComponentIcon from '../../../assets/images/less-component-icon.png'
import equalComponentIcon from '../../../assets/images/equal-component-icon.png'
import upComponentIcon from '../../../assets/images/up-component-icon.png'
import downComponentIcon from '../../../assets/images/down-component-icon.png'
import rsiComponentIcon from '../../../assets/images/rsi-icon.png'
import smaComponentIcon from '../../../assets/images/sma-icon.png'
import emaComponentIcon from '../../../assets/images/ema-icon.png'
import macdComponentIcon from '../../../assets/images/macd-icon.png'

export const functionalIndicators = [
    "total revenue", "operating expenses", "pre-tax income", "taxes", "non-operating income","cost of goods sold", "net income", "ebitda", "non-operating expenses", "operating income", "gross profit", "ebit"
]

export const typeMapper = {
    ifelse: {
        id: +new Date(),
        type: 'ifelse',
        logic: [

        ]
    },
    orCondition: {
        id: +new Date(),
        type: 'orCondition',
        logic: [

        ]
    },
    andCondition: {
        id: +new Date(),
        type: 'andCondition',
        logic: [

        ]
    },
}

export const mainAlgoCreationPanels = [
    // {
    //     id: 1,
    //     url: mpanel,
    //     title: 'Main Panel',
    //     type: 'algo_creation',
    //     icon: mpanelIcon
    // },
    {
        id: 1,
        url: andComponent,
        title: 'and',
        type: 'algo_creation',
        icon: andComponentIcon
    },
    {
        id: 2,
        url: orComponent,
        title: 'or',
        type: 'algo_creation',
        icon: orComponentIcon
    },
    {
        id: 3,
        url: lessComponent,
        title: '<',
        type: 'algo_creation',
        icon: lessComponentIcon
    },
    {
        id: 4,
        url: moreComponent,
        title: '>',
        type: 'algo_creation',
        icon: moreComponentIcon
    },
    {
        id: 5,
        url: equalComponent,
        title: '=',
        type: 'algo_creation',
        icon: equalComponentIcon
    },
    {
        id: 6,
        url: upComponent,
        title: 'crossover_above',
        type: 'algo_creation',
        icon: upComponentIcon
    },
    {
        id: 7,
        url: downComponent,
        title: 'crossover_below',
        type: 'algo_creation',
        icon: downComponentIcon
    },
]

export const technicalIndicators = [
    {
        id: 1,
        url: rsiComponent,
        title: "RSI",
        type: 'technical_indicators',
        icon: rsiComponentIcon
    },
    {
        id: 2,
        url: smaComponent,
        title: "SMA",
        type: 'technical_indicators',
        icon: smaComponentIcon
    },
    {
        id: 3,
        url: emaComponent,
        title: "EMA",
        type: 'technical_indicators',
        icon: emaComponentIcon
    },
    {
        id: 4,
        url: macdComponent,
        title: "MACD",
        type: 'technical_indicators',
        icon: macdComponentIcon
    }
]